import groupBy from "lodash.groupby";
import { startOfDay } from "date-fns";

export const isNotAFXItem = (isUrgent: boolean) => ({
  urgency
}: {
  urgency: number;
}) => {
  if (isUrgent) {
    return urgency < 3;
  }
  return true;
};

export const addStartOfDay = newsItem => {
  return {
    ...newsItem,
    startOfDay: startOfDay(newsItem.versionCreated)
  };
};

export const groupByStartOfDay = items => {
  return groupBy(items, "startOfDay");
};

export const orderGroupsBySortOrder = (groups, sortOrder = "asc") => {
  const dates = Object.keys(groups).sort((a, b) => {
    if (sortOrder === "asc") {
      return new Date(a).valueOf() - new Date(b).valueOf();
    }
    return new Date(b).valueOf() - new Date(a).valueOf();
  });

  return dates;
};

export default {};
